import PropTypes from 'prop-types';
import {
  Icon,
  USER_INTERFACE_ARROW_04_RIGHT,
  USER_INTERFACE_ARROW_04_LEFT,
} from '@bwoty-web/styleguide';
import './carouselNavArrow.scss';

const CarouselNavArrow = ({
  direction,
  setLeftActiveState,
  setRightActiveState,
  active,
  scrollInterval,
  carouselContainerId,
}) => {
  const handleClickScroll = () => {
    const carouselContainer = document.getElementById(carouselContainerId);
    const currentScrollLeft = carouselContainer.scrollLeft;
    const scrollChange =
      direction === 'right' ? scrollInterval : -scrollInterval;

    carouselContainer.scroll({
      left: currentScrollLeft + scrollChange,
      behavior: 'smooth',
    });

    const scrollLeftPosition =
      carouselContainer.scrollLeft +
      carouselContainer.offsetWidth +
      scrollChange;
    const containerScrollWidth = carouselContainer.scrollWidth;

    if (direction === 'right') {
      setLeftActiveState(true);

      if (scrollLeftPosition >= containerScrollWidth) {
        setRightActiveState(false);
      } else {
        setRightActiveState(true);
      }
    }

    if (direction === 'left') {
      setRightActiveState(true);

      if (currentScrollLeft - scrollInterval <= 0) {
        setLeftActiveState(false);
      } else {
        setLeftActiveState(true);
      }
    }
  };

  const icon =
    direction === 'right'
      ? USER_INTERFACE_ARROW_04_RIGHT
      : USER_INTERFACE_ARROW_04_LEFT;
  const fill = active ? 'rgb(255, 94, 0)' : '#ccc';

  return (
    <button
      className={`carousel-nav-arrow carousel-nav-arrow--${direction} carousel-nav-arrow--${
        active ? 'active' : 'disabled'
      }`}
      type="button"
      data-test={`nav-${direction}${!active ? '-disabled' : ''}-arrow`}
      onClick={handleClickScroll}
    >
      <Icon fill={fill} path={icon} size="m" />
    </button>
  );
};

CarouselNavArrow.propTypes = {
  active: PropTypes.bool.isRequired,
  setLeftActiveState: PropTypes.func.isRequired,
  setRightActiveState: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
  scrollInterval: PropTypes.number.isRequired,
  carouselContainerId: PropTypes.string.isRequired,
};

export default CarouselNavArrow;
